import { SvgIconComponent } from '@mui/icons-material'
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded'
import ChatBubbleRoundedIcon from '@mui/icons-material/ChatBubbleRounded'
import ExtensionRoundedIcon from '@mui/icons-material/ExtensionRounded'
import FlagRoundedIcon from '@mui/icons-material/FlagRounded'
import FolderRoundedIcon from '@mui/icons-material/FolderRounded'
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded'
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded'
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded'
import PlaylistAddCheckRoundedIcon from '@mui/icons-material/PlaylistAddCheckRounded'
import StarRoundedIcon from '@mui/icons-material/StarRounded'
import { PanelCategory } from './registry'
import { CARE_PLAN_TAB_ID, FEED_TAB_ID, MEDICAL_RECORD_TAB_ID, PROGRESS_TAB_ID } from './tabNavigationContext'

export type TabIconKey =
  | 'chat'
  | 'assignment'
  | 'monitorHeart'
  | 'extension'
  | 'star'
  | 'flag'
  | 'folder'
  | 'insights'
  | 'history'
  | 'checklist'

export const TAB_ICONS: Record<TabIconKey, SvgIconComponent> = {
  chat: ChatBubbleRoundedIcon,
  assignment: AssignmentRoundedIcon,
  monitorHeart: MonitorHeartRoundedIcon,
  extension: ExtensionRoundedIcon,
  star: StarRoundedIcon,
  flag: FlagRoundedIcon,
  folder: FolderRoundedIcon,
  insights: InsightsRoundedIcon,
  history: HistoryRoundedIcon,
  checklist: PlaylistAddCheckRoundedIcon,
}

export const ASSIGNABLE_TAB_ICONS: TabIconKey[] = ['star', 'flag', 'folder', 'insights', 'chat', 'assignment']

export type TabDefinition = {
  id: string
  label: string
  icon: TabIconKey
  kind: 'progress' | 'window' | 'feed'
  visible: boolean
  createdAt: string
  createdBy: string
}

const SHIPPED = { createdAt: '2026-01-01T00:00:00.000Z', createdBy: 'Meru Health' }

export const DEFAULT_TABS: TabDefinition[] = [
  // Fixed, not a window a coach stocks with panels — always the merged feed + patient chat.
  { id: FEED_TAB_ID, label: 'Feed', icon: 'history', kind: 'feed', visible: true, ...SHIPPED },
  { id: PROGRESS_TAB_ID, label: 'Progress', icon: 'monitorHeart', kind: 'progress', visible: true, ...SHIPPED },
  { id: MEDICAL_RECORD_TAB_ID, label: 'Medical record', icon: 'assignment', kind: 'window', visible: true, ...SHIPPED },
  { id: CARE_PLAN_TAB_ID, label: 'Care plan', icon: 'checklist', kind: 'window', visible: true, ...SHIPPED },
]

export const PERMANENT_TAB_IDS: readonly string[] = [MEDICAL_RECORD_TAB_ID, FEED_TAB_ID]

export const isPermanentTab = (id: string): boolean => PERMANENT_TAB_IDS.includes(id)

export const isDefaultTab = (id: string): boolean => DEFAULT_TABS.some((tab) => tab.id === id)

export const PAGE_LIBRARY_CATEGORIES: Partial<Record<string, PanelCategory[]>> = {
  [MEDICAL_RECORD_TAB_ID]: ['medicalRecord'],
  [CARE_PLAN_TAB_ID]: ['carePlanEditorPsychiatrist', 'carePlanViewer'],
}

export const PROGRESS_EXCLUDED_CATEGORIES: PanelCategory[] = ['carePlanEditorPsychiatrist']
